<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
}
html, body{
  height: 100%;
}
.fl{
  float: left;
}
.fr{
  float: right;
}
.clearfix{
  zoom: 1;
  clear:both;
}
.clearfix:after{
  visibility: hidden;
  display: block;
  content: " ";
  clear: both;
  height: 0;
  font-size: 0;
}
.title{
  color: #333;
  font-size: 20px;
  padding: 10px 0;
  border-bottom: 1px solid #ddd;
  margin-bottom: 30px;
}
.btn{
  width: 150px;
  height: 36px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue